/* eslint-disable react-hooks/exhaustive-deps */
import AssociadoAnexoPautaModal from 'components/Modal/__LEGACY__/AssociadoAnexoPautaModal/AssociadoAnexoPautaModal';

import Context from 'pages/Associado/AssembleiaAssociado/Context';
import { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IAssembleiasAssessorPauta } from 'store/modules/AssembleiasAssessorReducer';
import {
  IAssembleiaAssociadoPauta,
  IAssembleiaAssociadoPautaVoto,
} from 'store/modules/AssembleiasAssociadoReducer';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import {
  AssembleiaPautaStatus,
  TipoVotoPauta,
} from 'helpers/enums/AssembleiaPautaStatus';
import AssembleiaPautaNew from '../AssembleiaPautasNew/AssembleiaPautaNew';

export type IPauta = IAssembleiaAssociadoPauta | IAssembleiasAssessorPauta;

export interface IAssembleiaPautas {
  idEvento: number;
  pautas: Array<IAssembleiaAssociadoPauta | IAssembleiasAssessorPauta>;
  blockedUntilQuorum?: boolean;
  canParticipate?: boolean;
  cpfEfetivacaoPresencial?: string;
  loadingPautas?: boolean;
  bloqAlteraVoto?: boolean;
  updateVotoPresencial?: (
    idPauta: number,
    voto: IAssembleiaAssociadoPautaVoto[]
  ) => void;
  isColaborador?: boolean;
  canSeeResults?: boolean;
  isAssessor?: boolean;
}

export default function AssembleiaPautasNews({
  idEvento,
  pautas,
  loadingPautas,
  bloqAlteraVoto,
  blockedUntilQuorum,
  canParticipate,
  cpfEfetivacaoPresencial,
  updateVotoPresencial,
  canSeeResults,
  isAssessor,
}: IAssembleiaPautas) {
  const [opened, setOpened] = useState<number | null>(null);
  const [sortPauta, setSortPauta] = useState<boolean>(true);
  const [order, setOrder] = useState<Array<IPauta>>([]);
  // const [order, setOrder] = useState<any>();

  const { currentEvent } = useContext(Context);
  const dispatch = useDispatch();

  const toggleOpened = (reference: number, value: boolean) => {
    setOpened(value ? reference : opened === reference ? null : opened);
  };

  const sort = (condition: boolean) => setSortPauta(condition);

  useEffect(() => {
    const statusOrder = [
      AssembleiaPautaStatus.Liberada,
      AssembleiaPautaStatus.Bloqueada,
      AssembleiaPautaStatus.Encerrada,
    ];

    if (sortPauta) {
      const sortedPautas = [...pautas]
        .sort((a, b) => a.ordem - b.ordem)
        .sort(
          (a, b) =>
            statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status)
        )
        .sort((a, b) => {
          if (
            a.status === AssembleiaPautaStatus.Liberada &&
            b.status === AssembleiaPautaStatus.Liberada
          ) {
            return a.tempoRestante - b.tempoRestante;
          }
          return 0;
        })
        .sort((a, b) => {
          if (
            a.tipoVotoPauta === TipoVotoPauta.Vota &&
            !a.estaVotadoPorOutroRepresentante &&
            a.status === AssembleiaPautaStatus.Liberada &&
            !a.votos.length &&
            b.tipoVotoPauta === TipoVotoPauta.Vota &&
            !b.estaVotadoPorOutroRepresentante &&
            b.status === AssembleiaPautaStatus.Liberada &&
            b.votos.length
          ) {
            return -1;
          }
          return 0;
        });
      setOrder(sortedPautas);
    }

    if (
      sortPauta &&
      currentEvent?.contasDisponiveis?.length &&
      order.length &&
      order[0].status === AssembleiaPautaStatus.Liberada &&
      !order[0].votos.length &&
      order[0].tipoVotoPauta === TipoVotoPauta.Vota
    ) {
      toggleOpened(order[0].idPauta, true);
    }
  }, [currentEvent, pautas, sortPauta]);

  const openAnexoModal = useCallback(
    (idPauta: number, tituloPauta: string, isAssessor?: boolean) => {
      const mk = getUniqueKey();
      dispatch(
        openModal(AssociadoAnexoPautaModal, {
          modalKey: mk,
          onClose: () => dispatch(closeModal(mk)),
          onConfirm: () => Promise.reject,
          idPauta,
          idEvento,
          tituloPauta,
          isAssessor,
          preventMaskExit: true,
          mobileOnXS: false,
        })
      );
    },
    [dispatch, idEvento]
  );

  return (
    <Fragment>
      {pautas && order.length ? (
        order.map((pauta) => (
          <AssembleiaPautaNew
            pauta={pauta as IAssembleiaAssociadoPauta}
            key={pauta.idPauta}
            titulo={pauta.titulo}
            status={pauta.status}
            descricao={pauta.descricao}
            tempo={pauta.tempoRestante}
            blockedUntilQuorum={blockedUntilQuorum}
            bloqAlteraVoto={bloqAlteraVoto}
            canParticipate={canParticipate}
            cpfEfetivacaoPresencial={cpfEfetivacaoPresencial}
            updateVotoPresencial={updateVotoPresencial}
            idEventoParaEfetivacao={String(idEvento)}
            agency={pauta.codigoAgencia}
            nucleou={pauta.numeroNucleo}
            canSeeResults={canSeeResults}
            opened={opened === pauta.idPauta}
            toggleOpened={(value) => toggleOpened(pauta.idPauta, value)}
            loadingPautas={loadingPautas}
            sort={sort}
            hasAnexos={pauta.hasAnexos}
            onClickAnexos={() =>
              openAnexoModal(pauta.idPauta, pauta.titulo, isAssessor)
            }
          />
        ))
      ) : (
        <Fragment />
      )}
    </Fragment>
  );
}
